import React, { useContext } from "react";
import Brain from "../../components/assets/brain (1).svg";
import { Link } from "react-router-dom";
import { AuthContext } from "../../AuthContext";

const WelcomeChating = () => {
  const authContext = useContext(AuthContext);
  return (

  <div>
<div className="fw-bold fs-4 py-4 px-2">ChatBot 1.0</div>
<div
      id="welcome"
      style={{ height: "87vh" }}
      className="d-flex flex-column justify-content-between align-items-center pt-5 pb-2"
    >
      <div className="d-flex flex-column justify-content-center align-items-center">
        <img src={Brain} alt="" className=" w-50  my-3 mx-auto" />
        <p className="fs-3 fw-bold my-2 mx-auto ">How can I help you today</p>
      </div>
      <button className="w-50 px-3 py-3 border rounded-pill bg-primary text-white">
        <Link
          className="w-50 px-3 py-1  rounded-pill bg-primary text-white"
          to={`${
            authContext.auth && authContext.auth.user ? "/chatbot" : "/login"
          }`}
        >
           Start Chat With Bot
        </Link>
      </button>
    </div>

  </div>
  );
};

export default WelcomeChating;
